export default {
  id: 'ui-video.actions.PlayPause',
  appearance: ({
    context
  }) => {
    const {
      isPlaying,
      isLoading
    } = context;
    return {
      icon: 'fa fa-fw fa-play',
      iconOn: 'fa fa-fw fa-pause',
      iconOff: 'fa fa-fw fa-play',
      checkStyle: 'toggle',
      checked: isPlaying,
      disabled: isLoading
    };
  },
  matches: {
    use: 'videoPlayBar'
  },
  handles: () => true,
  perform: ({
    context
  }) => {
    const {
      onPlayPause
    } = context;
    onPlayPause();
  }
};